import * as helper from './helpers';

/**
 * Footer contains navigation to the previous and next project, this is used to handle it.
 */
export function updateFooter() {
  const footer_next = document.querySelector('footer a.next');
  const footer_previous = document.querySelector('footer a.previous');

  const data_next = work_wrapper.dataset.workNext;
  const data_previous = work_wrapper.dataset.workPrevious;

  if (footer_next && data_next || footer_next && !data_next) {
    updateFooterElm(footer_next, data_next)
  } else if (!footer_next && data_next) {
    updateFooterElm(createFooterElm('next'), data_next)
  }

  if (footer_previous && data_previous || footer_previous && !data_previous) {
    updateFooterElm(footer_previous, data_previous)
  } else if (!footer_previous && data_previous) {
    updateFooterElm(createFooterElm('previous'), data_previous)
  }
}

/**
 * In order to have consistency with dates on the website, they are all provided in milliseconds and parsed to a consistent format.
 */
export function updateDate() {
  document.querySelectorAll('[data-work-date]').forEach(elm => {
    elm.innerText = helper.formatDate(parseInt(elm.dataset.workDate))
  })
}

/**
 * Updates footer navigation if it already exists.
 * @param {HTMLElement} elm 
 * @param {string} data 
 */
function updateFooterElm(elm, data) {
  if (data) {
    elm.style.display = 'block';
    elm.href = data.split(';;;')[1];
    elm.children[1].innerText = data.split(';;;')[0]
  } else {
    elm.style.display = 'none'
  }
}

/**
 * Creates footer navigation if it doesn't exist.
 * @param {string} type 
 * @returns {HTMLElement}
 */
function createFooterElm(type) {
  const footer_wrapper = document.querySelector('footer div');
  const elm = document.createElement('a');
  
  elm.classList.add(type);
  elm.innerHTML = `<h2 class="twclr tc">${type == 'next' ? `next work -&gt;` : `&lt;- previous work`}</h2><p class="tcut"></p>`;

  if (type != 'next') {
    footer_wrapper.insertBefore(elm, footer_wrapper.children[0].nextElementSibling);
  } else {
    footer_wrapper.appendChild(elm);
  }

  return elm
}